// Calendário, categorias e links dos minissimulados do SOS Aprova 2026.
// Datas em horário de Brasília (-03:00). O status de cada área é calculado
// com a hora do servidor (ver utils/time.js), nunca só com o relógio do aluno.
// Com login, vale o startDate/endDate do documento em simulationlandings
// (`simulationSlug`); opensAt/closesAt daqui são a vitrine para quem não entrou.

export const TOTAL_QUESTIONS = 20;

//TODO: slugs
export const AREAS = [
  {
    slug: "linguagens",
    simulationSlug: "simulado-sos-2026-05-11",
    name: "Linguagens",
    block: 1,
    opensAt: "2026-11-05T00:00:00-03:00",
    closesAt: "2026-11-08T23:59:59-03:00",
    openLabel: "05/11",
    closeLabel: "08/11",
  },
  {
    slug: "ciencias-humanas",
    simulationSlug: "simulado-sos-2026-06-11",
    name: "Ciências Humanas",
    block: 1,
    opensAt: "2026-11-06T00:00:00-03:00",
    closesAt: "2026-11-08T23:59:59-03:00",
    openLabel: "06/11",
    closeLabel: "08/11",
  },
  {
    slug: "ciencias-da-natureza",
    simulationSlug: "simulado-sos-2026-12-11",
    name: "Ciências da Natureza",
    block: 2,
    opensAt: "2026-11-12T00:00:00-03:00",
    closesAt: "2026-11-15T23:59:59-03:00",
    openLabel: "12/11",
    closeLabel: "15/11",
  },
  {
    slug: "matematica",
    simulationSlug: "simulado-sos-2026-13-11",
    name: "Matemática",
    block: 2,
    opensAt: "2026-11-13T00:00:00-03:00",
    closesAt: "2026-11-15T23:59:59-03:00",
    openLabel: "13/11",
    closeLabel: "15/11",
  },
];

export const BLOCKS = [
  { id: 1, num: "BLOCO 1", title: "Linguagens e Ciências Humanas", dates: "05 a 08/11" },
  { id: 2, num: "BLOCO 2", title: "Ciências da Natureza e Matemática", dates: "12 a 15/11" },
];

export const CATEGORIES = [
  { max: 5, name: "SINTONIZANDO", msg: "Todo sinal começa assim. Agora é ajustar a antena." },
  { max: 10, name: "SINAL CHEGANDO", msg: "A base tá aí. Falta deixar a imagem nítida." },
  { max: 15, name: "NO AR", msg: "Você já tá transmitindo. Bora aumentar o volume." },
  { max: 20, name: "NA FREQUÊNCIA", msg: "Faltam só os detalhes pra cravar a nota." },
];

export const getCategory = (score) => CATEGORIES.find((c) => score <= c.max) || CATEGORIES[CATEGORIES.length - 1];

export const getArea = (slug) => AREAS.find((a) => a.slug === slug);

export const BLACK_URL = "https://aprovatotal.com.br/lp/black-total/";
export const BLACK_CLOSES_AT = "2026-11-27T23:59:59-03:00";
